/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Teams_Remove_Member_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to remove {email} from this team? They will lose access to team resources." |
*
* @param {Teams_Remove_Member_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_remove_member_confirm_description = /** @type {((inputs: Teams_Remove_Member_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Remove_Member_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie ${i?.email} wirklich aus diesem Team entfernen?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to remove ${i?.email} from this team? They will lose access to team resources.`)
});